import ContentLoader from 'react-content-loader';
import *as React from 'react';

export const ActivityListingLoader =props=>{
        return (
            <>
                {props.count && props.count > 0 && (
                Array.from({ length: props.count }, (_, i) => (
                    <ContentLoader
                    key={i+1}
                    height={68}
                    width={313}
                    speed={2}
                    style={{ background: "#fff", margin: "10px", padding: "1px 3px 10px 3px" }}
                >
                    <rect x="90" y="170" rx="3" ry="3" width="350" height="6.4" />
                    <rect x="11.84" y="20.67" rx="8" ry="8" width="148" height="12" />
                    <rect x="11.84" y="48.67" rx="8" ry="8" width="90" height="12" />
                    {/* <rect x="206.84" y="51.67" rx="10" ry="10" width="100.64" height="16" /> */}
                </ContentLoader>
                ))
            )}
        </>
    );
}



